<template>
    <section class="section section-lg bg-default text-center">
        <div class="container">
            <b-alert :show="alertDialog.enabled" :variant="alertDialog.succeeded ? 'success' : 'danger'" dismissible fade>{{ alertDialog.message }}</b-alert>
            <div class="row justify-content-xl-center">
                <div class="col-xl-12">
                    <h4 class="table-title">Problematic Subscriptions</h4>
                    <div class="table-novi table-custom-responsive">
                        <table class="table-custom table-hover">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Status</th>
                                    <th class="header-center">Created</th>
                                    <th class="header-center">CsMatNo</th>
                                    <th class="header-center">UserID</th>
                                    <th class="header-center">Action</th>
                                </tr>
                            </thead>

                            <tbody v-if="eowp.records.length">
                                <tr v-for="(obj, index) in eowp.records" v-bind:key="index">
                                    <td><a :href="stripe.dashboardLink + obj.id" target="_blank">{{ shrinkString(obj.id, 8, 5) }}</a></td>
                                    <td>{{ obj.status }}</td>
                                    <td class="column-date" :title="obj.created">{{ dateOnly(obj.created) }}</td>
                                    <td class="column-csmatno">{{ obj.csMatno }}</td>
                                    <td class="column-userid">{{ obj.userId }}</td>
                                    <td class="column-actions" v-if="eowp.table.loadAttempt">
                                        <span class="action" @click="viewDetails(obj.id)">Details</span> / 
                                        <span class="action" @click="triggerAction(obj.id, eowp.actionTypes.SYNC)">Sync</span> / 
                                        <span class="action" @click="triggerAction(obj.id, eowp.actionTypes.ABANDON)">Abandon</span>
                                    </td>
                                    <td v-if="!eowp.table.loadAttempt">{{ obj.userId }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="dropdown rows-control" v-if="eowp.records.length">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-html="eowp.dropdown.text"></button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                    <button v-for="(val, index) in eowp.table.rows_option" v-bind:key="index" class="dropdown-item" type="button" @click="dropdownSelect(val)">{{ val + " Rows" }}</button>
                </div>
            </div>

            <ul class="pagination-custom" v-if="eowp.records.length">
                <li v-for="(index) in eowp.table.pages" :key="index" class="page-item" :class="index == eowp.table.page ? 'active' : ''" @click="changePageNth(index)">
                    <a class="page-link" href="#" v-html="index"></a>
                </li>
            </ul>
            
            <ProblematicSubscription v-if="eowp.subscriptionDetailsDialog.enabled" :subscriptionId="eowp.subscriptionDetailsDialog.selectedId" v-on:close="eowp.subscriptionDetailsDialog.enabled = false" />
        </div>
    </section>
</template>

<style scoped>
/** styles that reflect within this component only */
.table-title{
    padding-top: 40px!important;
}
.section{
    padding-top: 20px!important;
}
.rows-control{
    padding-top: 35px;
}
.pagination-custom{
    margin-top: 30px;
}
.table-custom tr > td {
    cursor: default;
}
.column-date {
    padding-left: 0px;
    padding-right: 0px;
    text-align: center;
}
.column-userid {
    text-align: center;
}
.column-csmatno{
    text-align: center;
}
.column-actions{
    text-align: center;
}
.header-center{
    text-align: center;
}
.table-custom .action {
    font-weight: 600;
    cursor: pointer;
}
.table-custom .action:hover {
    color:red;
}
@media (min-width: 1400px) {
    .container {
        max-width: 1400px;
    }
}
</style>

<style>
.dialog-small-font{
    font-size: 10px !important;
}
</style>

<script>
import { BAlert } from "bootstrap-vue";
import Utils from '../../../../js/helpers/Utils';
import PaginationHelper from '../../../../js/helpers/PaginationHelper';
import UserModel from "../../../../js/models/UserModel";
import { mapActions, mapGetters } from 'vuex';
import ProblematicSubscription from './problematic-subscription';

export default {
    data() {
        return {
            eowp: {
                records: [
                    { // Dummy Sample Structure
                        id: "Loading.....",
                        status: "Loading...",
                        created: "Loading...",
                        csMatno: "Loading...",
                        userId: "Loading..."
                    }
                ],
                actionTypes: {
                    SYNC: 1,
                    ABANDON: 0,
                    texts: {
                        1: 'sync',
                        0: 'abandon',
                    },
                    notifs: {
                        1: 'The subscription record has successfully synced. ',
                        0: 'The subscription record has successfully abandoned. ',
                    },
                    prompts: {
                        1: {
                            title: 'アカウントページの反映を行います[SYNC]', //Reflects the account page [SYNC].
                            description: '1時間以内(毎正時)に連携が開始され、アカウントページに反映されます。<br/>本当に実施してもよろしいですか。<br/><span class="dialog-small-font">※ ユーザーにメールは飛ばないため、必要であれば送信をお願いします。</span>', //Within an hour (every hour), the linkage will be initiated and reflected on your account page. Are you sure you want to implement this? Please send us an email if necessary, as no email will be sent to the user.
                        },
                        0: {
                            title: 'レコードを今後の連携対象から外します [ABANDON]', //Record will be removed from future collaboration [ABANDON].
                            description: 'アカウントページには反映されず、今後の連携からは外れます。<br/>本当に実施してもよろしいですか。<br/><span class="dialog-small-font">※ Stripe上の変更が必要な場合はStripeのダッシュボードにてお願いします。</span>', //This will not be reflected on the account page and will be removed from future linkages. Are you sure you want to implement this? ※ If any updates necessary to the Stripe, please do so in Stripe dashboard.
                        }
                    }
                },
                table: {
                    page: 1,
                    pages: 1,
                    rows: 5,
                    rows_option: [5, 10, 20, 50, 100],
                    loadAttempt: 0,
                },
                dropdown: {
                    default: {
                        text: '5 Rows',
                        value: '5', // Has to match with table.rows
                    },
                    text: '5 Rows',
                    value: 5 // Has to match with table.rows
                },
                subscriptionDetailsDialog: {
                    enabled: false,
                    selectedId: ''
                },
                pageControlName: 'problematic_subscription',
            },
            stripe: {
                dashboardLink: 'https://dashboard.stripe.com/subscriptions/',
            },
            dialogParams: {
                defaultOptions: {
                    loader: false,
                    okText: 'OK',
                    cancelText: 'Cancel',
                    animation: 'zoom',
                    backdropClose: true,
                    html: true,
                },
            },
            alertDialog: {
                enabled: false,
                succeeded: false,
                message: '',
            }
        };
    },
    created() {
        //Initialize all processes here
        let params = {
            userId: this.sessionDetails.userId,
            sessionId: this.sessionDetails.sessionId,
        };
        this.ssrEnabled(params).then(res => {
            if(res.status != UserModel.STATUS_SUCCESS || res.status_code != UserModel.STATUS_SUCCESS || !res.records){
                this.$router.push("/products");
            }
        });

        this.dropdownSelect();
    },
    computed: {
        //Auto execute codes every time there's a change of values here
        ...mapGetters({
            sessionDetails: 'user/session_details',
            problematic_records: 'ssr/subscription_records',
        }),
    },
    methods: {
        //All methods here
        ...mapActions({
            getProblematicRecords: 'ssr/getProblematicRecords',
            updateProblematicRecord: 'ssr/updateProblematicRecord',
            ssrEnabled: 'ssr/ssrEnabled',
        }),
        triggerAction(subId, actionType){
            this.alertDialog.enabled = false;
            if(Utils.isEmpty(subId) || Utils.isEmpty(actionType)) return;

            let actualTitle = this.eowp.actionTypes.prompts[actionType].title;
            let actualDescription = this.eowp.actionTypes.prompts[actionType].description;
            this.$dialog.confirm({
                title: actualTitle,
                body: actualDescription + "<br/><br/> <b>Subscription Id:</b> " + subId,
            }, this.dialogParams.defaultOptions)
            .then(() => { this.updateRecord(subId, actionType); })
            .catch(() => {});
        },
        updateRecord(subId, actionType){
            let params = {
                userId: this.sessionDetails.userId,
                sessionId: this.sessionDetails.sessionId,
                subscriptionId: subId,
                infoRequestType: actionType,
            };
            this.updateProblematicRecord(params).then(res => {
                if(res.status_code == 'SUCCESS'){
                    this.updateTable();
                    this.notify(true, this.eowp.actionTypes.notifs[actionType] + "(subId=" + subId + ")");
                } else if (Utils.isEmpty(res.status_code) && res.status == 'ERROR') { // Session expired
                    this.$router.push("/signout");
                    return;
                } else {
                    this.notify(false, "An error has occurred while trying to execute the said request. Please try again.");
                }
            });
        },
        notify(succeeded, message){
            this.alertDialog.enabled = true;
            this.alertDialog.succeeded = succeeded;
            this.alertDialog.message = message;

            let vm = this;
            setTimeout(() => { vm.alertDialog.enabled = false; }, 8000);
        },
        shrinkString(str, preCharLength, postCharLength){
            return PaginationHelper.shrinkStr(str, preCharLength, postCharLength, "...");
        },
        dateOnly(dateTimeStr){
            if(Utils.isEmpty(dateTimeStr)) return dateTimeStr;
            return dateTimeStr.split("T")[0];
        },
        viewDetails(subId){
            this.eowp.subscriptionDetailsDialog.enabled = true;
            this.eowp.subscriptionDetailsDialog.selectedId = subId;
        },
        updateTable(){
            let params = {
                userId: this.sessionDetails.userId,
                sessionId: this.sessionDetails.sessionId,
                page: this.eowp.table.page,
                rows: this.eowp.table.rows,
            };
            this.getProblematicRecords(params).then(() => {
                this.eowp.records = [];
                if(this.problematic_records && this.problematic_records.subscriptions && this.problematic_records.subscriptions.length > 0){
                    this.updatePageNumbers(this.problematic_records.total);
                    this.problematic_records.subscriptions.forEach((record) => {
                        let row = {
                            id: record.subscriptionId,
                            status: record.status,
                            created: record.createdDate,
                            csMatno: record.csMatNo,
                            userId: record.userId,
                        }; 
                        this.eowp.records.push(row);
                    });
                    this.eowp.table.loadAttempt += 1;
                }
            });
        },
        dropdownSelect(value){
            if(Utils.isEmpty(value)){
                this.eowp.dropdown.text  = this.eowp.dropdown.default.text;
                this.eowp.dropdown.value = this.eowp.dropdown.default.value;
                this.eowp.table.rows = this.eowp.dropdown.value;
                this.updateTable();
                return;
            }
            this.eowp.dropdown.text  = value + " Rows";
            this.eowp.dropdown.value = value;
            this.eowp.table.rows = value;
            this.eowp.table.page = 1;
            this.updateTable();
        },
        updatePageNumbers(totalRecords){
            this.eowp.table.pages = Math.ceil(totalRecords / this.eowp.table.rows);
        },
        changePageNth(pageNth){
            if(Utils.isEmpty(pageNth)) return;
            this.eowp.table.page = pageNth;
            this.updateTable();

            /** Guide - If we want to control number of pagination buttons when it goes beyond expected numbers
             * - Add another method that will compute the following:
             *      - Generate array of page ranges
             *      - Max 10 page ranges + 1st & Last Page buttons
             *      - If pageNth is in the middle of total pages, make the array of pages range like below:
             *          1st Page, P-5, P-4, P-3, P-2, P-1, P, P+1, P+2, P+3, P+4, Last Page
             * - Use the array of pages range as reference of page buttons 
             */
        }
    },
    components: {
        // eslint-disable-next-line
        BAlert, ProblematicSubscription
    }
};
</script>
